export const QUERY_PRODUCTS_BY_IDS = `
  query productsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        productType
        handle
        tags
        release_date: metafield(namespace: "details", key: "release_date") {
          value
        }
        msrp: metafield(namespace: "details", key: "msrp") {
          value
        }
        variants(first: 5) {
          edges {
            node {
              id
              title
              availableForSale
              price {
                amount
              }
              special_offer_percent: metafield(namespace: "special_offer", key: "percent_off") {
                key
                value
                type
              }
              early_bird_percent: metafield(namespace: "early_bird", key: "percent_off") {
                key
                value
                type
              }
            }
          }
        }
        options(first: 5) {
          id
          name
          values
        }
        media(first: 2) {
          edges {
            node {
              ... on MediaImage {
                mediaContentType
                image {
                  url
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default {
  QUERY_PRODUCTS_BY_IDS,
};
